export class UnsavedChangesManager {
    hasUnsavedChanges: boolean = false;
    clearCb?: () => void;
    saveCb?: () => void;

    beforeUnloadHandler = (event: any) => {
        event.preventDefault();
    };

    declareUnsavedChanges = (clearCb?: () => void, saveCb?: () => void) => {
        window.addEventListener("beforeunload", this.beforeUnloadHandler);
        this.hasUnsavedChanges = true;
        this.clearCb = clearCb;
        this.saveCb = saveCb;
    }

    declareNoUnsavedChanges = () => {
        window.removeEventListener("beforeunload", this.beforeUnloadHandler);
        this.hasUnsavedChanges = false;
        this.clearCb = undefined;
        this.saveCb = undefined;
    }

    clearAndLeave = () => {
        if (this.clearCb) {
            this.clearCb();
        }
        this.leave();
    }

    saveAndLeave = () => {
        if (this.saveCb) {
            this.saveCb();
        }
        this.leave();
    }

    leave = () => {
        window.removeEventListener("beforeunload", this.beforeUnloadHandler);
        this.hasUnsavedChanges = false;
        this.clearCb = undefined;
        this.saveCb = undefined
    }
}

export const unsavedChangesManager = new UnsavedChangesManager();
